import axios from "axios"

const controller = "/mixer"

const MixerService = {
    buscar: async (request) => {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    registrar: async (request) => {
        const { data } = await axios.post(`${controller}/registrar`, request)
        return data
    },
    obtener: async (request) => {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    modificar: async (request) => {
        const { data } = await axios.post(`${controller}/modificar`, request)
        return data
    },
}

export default MixerService